import { Button } from "@/components/ui/button";
import { cn } from "@/lib/class-control";
import { Plus } from "lucide-react";
import { Link } from "wouter";

export function HeaderSlot() {
  return (
    <Link href="/contratual/contratos/novo">
      <Button size="sm" className={cn("bg-[#7846ff] hover:bg-[#7846ff]/90 flex h-btn-default",
        "items-center justify-center rounded-lg w-[160px]")}>
        <Plus className="w-4 h-4" />
        <span className="font-bold text-xs text-[#f5f2ff]">
          Solicitar Contrato
        </span>
      </Button>
    </Link>
  )
}